/**
 * RoleField — input de papel do participante com sugestões (datalist). O DTO
 * aceita `role` como texto livre (validado por bond.type no Registry), então
 * NÃO restringimos a um <select>: oferecemos ROLE_SUGGESTIONS como autocomplete.
 */

import { ROLE_SUGGESTIONS } from './participants-labels';

interface RoleFieldProps {
  id: string;
  value: string;
  onChange: (role: string) => void;
}

export function RoleField({ id, value, onChange }: RoleFieldProps): JSX.Element {
  const listId = `${id}-suggestions`;
  return (
    <label className="bpt-field" htmlFor={id}>
      <span className="bpt-field__label">Papel</span>
      <input
        id={id}
        className="bpt-input"
        list={listId}
        placeholder="ex: holder, account-manager…"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <datalist id={listId}>
        {ROLE_SUGGESTIONS.map((r) => (
          <option key={r} value={r} />
        ))}
      </datalist>
    </label>
  );
}
